import { Alert } from '@@/Alert';
import { ExternalLink } from '@@/ExternalLink';

// Not versioned through useDocsUrl: the FAQ is published once, outside the
// LTS/STS doc sets.
const ADDON_REQUIREMENTS_FAQ_URL =
  'https://docs.portainer.io/faqs/getting-started/add-on-requirements';

/**
 * AddonsRequirementsInfo points admins at the FAQ covering what Portainer
 * needs in place for add-ons to install and work.
 */
export function AddonsRequirementsInfo() {
  return (
    <div className="row mt-4">
      <div className="col-sm-12">
        <Alert color="info">
          <div>
            Add-ons only work when Portainer is installed and configured in a
            supported way. Add-ons marked <strong>Pre-release</strong> may
            change and should not be used in production. The add-ons{' '}
            <ExternalLink
              to={ADDON_REQUIREMENTS_FAQ_URL}
              data-cy="addons-requirements-faq-link"
            >
              FAQ
            </ExternalLink>{' '}
            covers setup requirements and links to further documentation.
          </div>
        </Alert>
      </div>
    </div>
  );
}
